<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>Pesaje {{ title }}</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <div class="row">
        <div class="col s6 relative center w46">
            <strong>{{ galpon }}</strong>
        </div>
        <div class="col s6 relative center w46">
            <strong>{{ lote }}</strong>
        </div>
        <div class="col s12 relative">
            <div *ngFor="let semana of semanas;" class="card horizontal semana" (click)="goToSemana(semana.idsemana)">
                <div class="col s2">
                    <p class="icon-mediano">
                        <i class="fa fa-calendar"></i>
                    </p>
                </div>
                <div class="col s10">
                    <i class="nube fa fa-{{ semana.cloud }}"></i>
                    <div>Fecha de Pesaje:<br>
                        <strong>{{ semana.fecha_creacion | date : 'yyyy-MM-dd HH:mm' }}</strong>
                    </div>
                    <div class="row mb0">
                        <div class="col s6">
                            Semana<br>
                            <strong>{{ semana.semana }}</strong>
                        </div>
                            <div class="col s6">
                                # de aves<br>
                                <strong>{{ semana.aves }}</strong>
                            </div>
                    </div>
                    <div>Promedio<br>
                        <strong>{{ semana.promedio }} gr.</strong>
                    </div>
                </div>
            </div>
            <div *ngIf="semanas.length == 0">
                <p>&nbsp;</p>
                <p class="text-center">No se encontraron semanas registradas</p>
            </div>
            <a (click)="agregarPeso(idcorral)" *ngIf="permitir && permitirInternet" class="btn-floating btn-large waves-effect waves-light red"><i class="fa fa-plus"></i></a>
        </div>
    </div>
</div>
